// Action Types
export const actionTypes = {
  GET_MAINTAINED_VALUES: "GET_MAINTAINED_VALUES",
  GET_MAINTAINED_VALUES_SUCCESS: "GET_MAINTAINED_VALUES_SUCCESS",
  GET_MAINTAINED_VALUES_FAILED: "GET_MAINTAINED_VALUES_FAILED",

  GET_MARKETING_PARTNERS: "GET_MARKETING_PARTNERS",
  GET_MARKETING_PARTNERS_SUCCESS: "GET_MARKETING_PARTNERS_SUCCESS",
  GET_MARKETING_PARTNERS_FAILED: "GET_MARKETING_PARTNERS_FAILED",

  POST_MARKETING_PARTNERS: "POST_MARKETING_PARTNERS",
  POST_MARKETING_PARTNERS_SUCCESS: "POST_MARKETING_PARTNERS_SUCCESS",
  POST_MARKETING_PARTNERS_FAILED: "POST_MARKETING_PARTNERS_FAILED",

  MARKET_SEARCH: "MARKET_SEARCH",
  MARKET_SEARCH_SUCCESS: "MARKET_SEARCH_SUCCESS",
  MARKET_SEARCH_FAILED: "MARKET_SEARCH_FAILED",

  SAVE_REASON: "SAVE_REASON",
  SAVE_REASON_SUCCESS: "SAVE_REASON_SUCCESS",
  SAVE_REASON_FAILED: "SAVE_REASON_FAILED"
};

// Action creators
export const actionCreators = {
  getMarketingPartners: params => ({
    type: actionTypes.GET_MARKETING_PARTNERS,
    params
  }),

  postMarketingPartners: params => ({
    type: actionTypes.POST_MARKETING_PARTNERS,
    params
  }),

  getMaintainedValues: params => ({
    type: actionTypes.GET_MAINTAINED_VALUES,
    params
  }),
  searchMarket: params => ({
    type: actionTypes.MARKET_SEARCH,
    params
  }),
  saveReason: params => ({
    type: actionTypes.SAVE_REASON,
    params
  })
};

// Reducer
const initialState = {
  marketingPartners: [],
  titles: [],
  countries: [],
  regions: [],
  civilStatus: [],
  occupations: [],
  positions: [],
  suffixes: [],
  brokerRoles: [],
  salesGroups: [],
  brokerTypes: [],
  agentStatus: [],
  inputTaxCodes: [],
  iTextGroups: [],
  banks: [],
  currencies: [],
  isLoading: false,
  error: null,
  result: null,
  marketResult: [],
  isSearching: false,
  appealReason: null,
  isLoadingMarketingPartner: false,
  isLoadingMarketingPartnerPost: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MARKET_SEARCH:
      return Object.assign({}, state, {
        isSearching: true,
        error: null,
        marketResult: []
      });
    case actionTypes.MARKET_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        isSearching: false,
        error: null,
        marketResult: action.payload
      });
    case actionTypes.MARKET_SEARCH_FAILED:
      return Object.assign({}, state, {
        isSearching: false,
        error: action.error
      });

    case actionTypes.SAVE_REASON:
      return Object.assign({}, state, {
        error: null,
        appealReason: null
      });
    case actionTypes.SAVE_REASON_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        saveReason: action.payload
      });
    case actionTypes.SAVE_REASON_FAILED:
      return Object.assign({}, state, {
        error: action.error
      });

    case actionTypes.GET_MAINTAINED_VALUES:
      return Object.assign({}, state, {
        isLoading: true,
        error: null
      });

    case actionTypes.GET_MAINTAINED_VALUES_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        titles: action.payload.titles,
        countries: action.payload.countries,
        regions: action.payload.regions,
        civilStatus: action.payload.civil_statuses,
        occupations: action.payload.occupations,
        positions: action.payload.positions,
        suffixes: action.payload.suffixes,
        brokerRoles: action.payload.broker_roles,
        salesGroups: action.payload.sales_group,
        brokerTypes: action.payload.broker_types,
        agentStatus: action.payload.agent_statuses,
        inputTaxCodes: action.payload.input_tax_codes,
        iTextGroups: action.payload.i_text_groups,
        banks: action.payload.banks,
        currencies: action.payload.currencies
      });

    case actionTypes.GET_MAINTAINED_VALUES_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error
        // marketingPartners: []
      });

    case actionTypes.POST_MARKETING_PARTNERS:
      return Object.assign({}, state, {
        isLoadingMarketingPartnerPost: true,
        error: null,
        result: null
      });

    case actionTypes.POST_MARKETING_PARTNERS_SUCCESS:
      return Object.assign({}, state, {
        isLoadingMarketingPartnerPost: false,
        error: null,
        result: action.payload
      });

    case actionTypes.POST_MARKETING_PARTNERS_FAILED:
      return Object.assign({}, state, {
        isLoadingMarketingPartnerPost: false,
        error: action.error,
        result: false
      });

    case actionTypes.GET_MARKETING_PARTNERS:
      return Object.assign({}, state, {
        isLoadingMarketingPartner: true,
        error: null,
        marketingPartners: []
      });

    case actionTypes.GET_MARKETING_PARTNERS_SUCCESS:
      return Object.assign({}, state, {
        isLoadingMarketingPartner: false,
        error: null,
        marketingPartners: action.payload
      });

    case actionTypes.GET_MARKETING_PARTNERS_FAILED:
      return Object.assign({}, state, {
        isLoadingMarketingPartner: false,
        error: action.error,
        marketingPartners: []
      });

    default:
      return state;
  }
};
